<!--设备管理-项目管理 列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >
      <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline"  >

          <a-form-item
            label="内容"  class="ant-form-item2 "
          >
            <a-input v-model="searchkey"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handlePageList" html-type="button" >
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      列表表格-->
      <div>
        <a-button type="primary" html-type="button" @click="toAddPage">
          新增
        </a-button>
        <a-table :columns="columns" :data-source="datalist" >
          <span slot="action" slot-scope="text, record">
            <a @click="toEditPage(record)">修改</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteModal(record)">删除</a>
          </span>
        </a-table>
      </div>
    </a-card>

    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>

  </div>
</template>


<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'




  export default {
    name: 'platformManagementList',
    components: {
      TitleCard
    },
    data() {
      return {
        record:{},
        titleMsg1:"设备管理",
        titleMsg2:'项目管理',
        titleMsg3:'项目管理',
        datalist:[],

        columns:[{
          title: '企业ID',
          dataIndex: 'cEntID',
          key: 'cEntID',
          ellipsis: true,
        },
          {
            title: '所属项目',
            dataIndex: 'cSystemCode',
            key: 'cSystemCode',
            ellipsis: true,
          },

          {
            title: '项目编码',
            dataIndex: 'cPlatformCode',
            key: 'cPlatformCode',
            ellipsis: true,
          },
          {
            title: '项目名称',
            dataIndex: 'cPlatformName',
            key: 'cPlatformName',
            ellipsis: true,
          },
          {
            title: '创建人',
            dataIndex: 'cCreateUserName',
            key: 'cCreateUserName',
            ellipsis: true,
          },
          {
            title: '创建时间',
            dataIndex: 'dCreateDate',
            key: 'dCreateDate',
            ellipsis: true,
          },
          {
            title: '备注',
            dataIndex: 'Remark',
            key: 'Remark',
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          }],

        deleteModalVisible:false,
        searchkey:"",
        cEntID:""
      }
    },
    mounted () {
      let that=this;

      that.cEntID=that.$store.getters.User.cEntID;
      that.handlePageList();
    },
    methods:{
      //列表
      async handlePageList(){
        let that=this;
        let param={keyword:that.searchkey,cEntID:that.cEntID,cSystemCode:'设施园艺'};
        let res= await that.$http.post('EntPlatformInfo/List ',param)

        if(res.data.code=="200"){
          that.datalist= res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },
      //删除
      async handleDelete(){
        let that=this;
        let param=null;
        let res=await that.$http.post('EntPlatformInfo/Delete?ids='+that.record.ID,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.handlePageList();
        }
        else{
          that.$message.error(res.message)

        }
      },

      toAddPage(){
        this.$router.push({path:'/equipmentManagement/platformManagement/platformManagementForm'});

      },
      toEditPage(obj){
        this.$router.push({name:'PlatformManagementForm',params:{ID:obj.ID}});
      },
      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true;
      }


    }
  }
</script>
